import React from "react" ;

/**
 * This component is used to define multiple variations of drawings that should
 * be rendered inside a [[CanvasThrobber]]. This must be a top-level child of
 * the CanvasThrobber.
 */
// tslint:disable-next-line variable-name
export const CanvasThrobberVariation: React.FC = () => null;

/**
 * Type specification of the variation, so that we can safely identify it even
 * if react-hot-loader was used.
 */
export const typeOfCanvasThrobberVariation = (<CanvasThrobberVariation />).type;
